import { HttpErrorResponse } from '@angular/common/http';
import { DID_TYPE } from 'voxloud-types/dist/models';

export enum TABS_TYPE {
  immediate = 'immediate',
  renewal = 'renewal'
}

export enum LOADING_TYPE {
  box = 'box',
  lines = 'lines'
}

export enum PRODUCT_TYPE {
  phone_number = 'phone_number',
  fax = 'fax'
}

export enum COUPON_ERROR {
  EXPIRED = 'EXPIRED',
  NOT_FOUND = 'NOT_FOUND',
  API_ERROR = 'API_ERROR'
}

export interface CouponError {
  type: COUPON_ERROR;
  data: HttpErrorResponse | CouponResponse;
}

export interface LineItem {
  immediate: {
    recurrent: { plans: string[], addons: string[] }
    one_time: { addons: string[] },
    estimation: EstimateResponse
  },
  renewal: {
    recurrent: { plans: string[], addons: string[] }
    one_time: { addons: string[] },
    estimation: EstimateResponse
  }
}

export interface EstimationRequest {
  product: PRODUCT_TYPE;
  default_addon: PRODUCT_TYPE;
  country_code: string;
  did_type: DID_TYPE;
  coupon_id?: string;
  end_of_term?: boolean;
  did_id?: number;
}

export interface EstimateResponse {
  total_without_taxes: number;
  taxes: number;
  total_with_taxes: number;
  credits_applied: number;
  currency_code: string;
  line_items: EstimateItem[];
  discount_items: DiscountItem[];
}

interface EstimateItem {
  id: string;
  from: string | Date;
  to: string | Date;
  description: string;
  quantity: number;
  unit_amount: number;
  tax_amount: number;
  discount_amount: number;
  total_amount: number;
  entity_id: string;
  entity_type: string;
  pricing_model: string;
  tax_rate: number;
}

export interface DiscountItem {
  amount: number;
  coupon_id: string;
  discount_type: string;
  line_item_id: string;
}

export interface CouponViewModel {
  id: string;
  name: string;
  type: string;
  duration: string;
  amount: number;
}

export interface CouponResponse {
  couponDuration: string;
  currencyCode: string;
  discountAmount: number;
  discountPercentage: number;
  discountType: string;
  durationMonth: number;
  id: string;
  invoiceName: string;
  invoiceNotes: string;
  name: string;
  scope: string;
  status: string;
  validTill: string;
}
